import { FC } from 'react';
import { ButtonProps, NavigateButton } from './Buttons';
import { CalendlyButton } from './CalendlyButton';
import { StepperButton } from './StepperButton';

export const ButtonWrapper: FC<ButtonProps> = (props) => {
	const {
		data: {
			fields: { actionType },
		},		
	} = props;

	switch (actionType) {
		case 'Navigate': {
			return <NavigateButton {...props} />;
		}

		case 'Start a quote': {
			return <StepperButton {...props} />;
		}

		case 'Book a call': {
			return <CalendlyButton {...props} />;
		}

		default: {
			return null;
		}
	}
};
